
require.register("react-addons-create-fragment/index.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-addons-create-fragment");
  (function() {
    module.exports = require('react/lib/ReactFragment').create;
  })();
});